module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fvQaf"))).then(() => parcelRequire('fThBo'));